<template>
  <div id="Refill">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>รายการบัญชีผู้ใช้</h2>
          <hr>
          <b-table :busy="!dataReady" hover bordered small :items="items" :fields="fields">

            <!-- A custom formatted column -->
            <template #cell(userType)="data">
              {{ data.value === 'A' ? 'แอดมิน' : 'ผู้ใช้ทั่วไป' }}
            </template>

            <template #cell(editUser)="data">
              <b-button @click="openDataAccount(data.item)" v-b-tooltip.hover title="แก้ไขบัญชีผู้ใช้" size="sm" variant="info">
                <f-icon icon="user-edit"></f-icon>
              </b-button>
              <b-button @click="delConfirm(data.item)" v-b-tooltip.hover title="ลบบัญชีผู้ใช้" size="sm" variant="danger">
                <f-icon icon="trash"></f-icon>
              </b-button>
            </template>

          </b-table>
          
          <b-modal id="modalAccount" hide-footer>
            <template #modal-title>
              ข้อมูลผู้ใช้
            </template>
            <div class="d-block">
              <label for="form_usercode" class="mb-1">รหัสสมาชิก:</label>
              <b-form-input id="form_usercode" class="mb-2" autocomplete="off" v-model="form.userCode" type="text" ></b-form-input>
              <p><b>ชื่อ-นามสกุล:</b> {{form.firstName}} {{form.lastName}}</p>
              <!-- <p><b>เบอร์โทรศัพท์:</b> {{form.telephoneNumber}}</p> -->

              <label for="form_tel" class="mb-1">เบอร์โทรศัพท์:</label>
              <b-form-input id="form_tel" autocomplete="off" class="mb-2" v-model="form.telephoneNumber" type="tel" maxlength="10"></b-form-input>
              <label for="form_addr"><b>ที่อยู่จัดส่ง:</b> </label>
              <b-form-textarea id="form_addr" class="mb-2" v-model="form.address" rows="6"></b-form-textarea>

              <b-form-group label="ประเภทผู้ใช้" v-slot="{ ariaDescribedby }">
                <b-form-radio-group :options="options" :aria-describedby="ariaDescribedby" v-model="form.userType"></b-form-radio-group>
              </b-form-group>
            </div>
            <b-button class="mt-3" block @click="onUpdate">แก้ไขข้อมูล</b-button>
          </b-modal>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Refill",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataAccount()
  },
  data() {
    return {
      options: [
          { text: 'แอดมิน', value: 'A' },
          { text: 'ผู้ใช้ทั่วไป', value: 'U' },
      ],
      fields: [
        { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'firstName', label: 'ชื่อจริง' },
        { key: 'lastName', label: 'นามสกุล' },
        { key: 'telephoneNumber', label: 'เบอร์โทรศัพท์' },
        { key: 'userType', label: 'ประเภทผู้ใช้' },
        { key: 'editUser', label: 'จัดการข้อมูล', tdClass: 'text-center', class: 'w-90' }
      ],
      items: [],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        userCode: '',
        userId: '18',
        userName: 'test123',
        address: 'asdfsadf',
        firstName: 'test',
        lastName: 'test',
        telephoneNumber: '0987654321',
        userType: 'U',
        LAST_USER: ''

      },
      dataReady: false,
    };
  },
  methods: {
    openDataAccount(dt) {
      this.form.userCode = dt.userCode
      this.form.userId = dt.userId
      this.form.userName = dt.userName
      this.form.address = dt.address
      this.form.firstName = dt.firstName
      this.form.lastName = dt.lastName
      this.form.telephoneNumber = dt.telephoneNumber
      this.form.userType = dt.userType
      this.form.LAST_USER = this.userData.userName
      this.$bvModal.show('modalAccount')
    },
    getDataAccount() {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_list",
          {
            headers: this.getHeaderAPI('User_list')
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            console.log('getDataAccount', rs)
            this.items = rs.data
            this.dataReady = true;
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลผู้ใช้ได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
      } else {
        this.$router.push('/Login')
      }      
    },
    delConfirm (dt) {
      var name = dt.userCode || dt.firstName + " " + dt.lastName

      this.$swal({
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบบัญชีผู้ใช้ ' + name + ' ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delAccount(dt.userId)
        }
      })
    },
    onUpdate (){
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_update",
          this.form,
          {
            headers: this.getHeaderAPI('User_update', this.form.userName)
          }
        )
        .then(async (response) => {
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แก้ไขข้อมูลผู้ใช้เรียบร้อย","success")
              .then((result) => {
                this.$bvModal.hide('modalAccount')
              })
            this.dataReady = true

            this.getDataAccount()
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลผู้ใช้ได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลผู้ใช้ได้","error")
          this.dataReady = true
        })
    },
    delAccount (dt) {
      var LASTuserName = this.userData.userName
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_delete",
          {
            userId: dt,
            userName: this.userData.userName,
            LAST_USER: LASTuserName
          },
          {
            headers: this.getHeaderAPI('User_delete', this.userData.userName)
          }
        )
        .then(async (response) => {
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ลบบัญชีผู้ใช้เรียบร้อย","success")
            this.dataReady = true
            this.getDataAccount()
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถลบบัญชีผู้ใช้ได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลบบัญชีผู้ใช้ได้","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Log/TopUp.vue